module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-23-3ebaf0cd3e99ce40883417f895554be3.png";